
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { getEvaluationRoundLabel } from "@/utils/formatters";

interface RoundData {
  round_name: string;
  total_taken: number;
  average_score: number;
}

interface AssessmentRoundsTableProps {
  data: RoundData[];
}

export function AssessmentRoundsTable({ data }: AssessmentRoundsTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Assessment Round Statistics</CardTitle>
        <CardDescription>
          Number of candidates and average scores by evaluation round
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Round</TableHead>
              <TableHead className="text-right">Candidates Taken</TableHead>
              <TableHead className="text-right">Average Score</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} className="text-center text-muted-foreground">
                  No assessment data available
                </TableCell>
              </TableRow>
            ) : (
              data.map((round) => (
                <TableRow key={round.round_name}>
                  <TableCell>
                    <Badge variant="outline">
                      {getEvaluationRoundLabel(round.round_name as any)}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge variant="secondary">
                      {round.total_taken}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right font-medium">
                    {round.average_score > 0 ? round.average_score.toFixed(1) : 'N/A'}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
